module.exports = __webpack_public_path__ + "static/img/retail-clinic.fb6a4f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/retail-clinic.jpg
// module id = 220
// module chunks = 1